import { Icon } from "@@/shared/icons/icon";
import { faFrog } from "@fortawesome/pro-solid-svg-icons";

const ImportantComponent = () => {
    const width = window.innerWidth;
    if (width < 2500) {
        return null;
    }
    return (
        <div
            css={{
                position: "absolute",
                zIndex: 9999,
                bottom: 0,
                right: 0,
                paddingRight: 20,
            }}>
            <Icon icon={faFrog} size={1.5} color={"#ebfaf7"} />
        </div>
    );
};

export default ImportantComponent;
